document.addEventListener('DOMContentLoaded', function() {
  const globalMobileSearch = {
    input: document.querySelector('.global-mobile-search-input'),
    form: document.querySelector('.global-mobile-search-form'),
    
    init: function() {
      if (!this.input || !this.form) return;
      
      this.setupEventListeners();
      this.setupAnalytics();
      console.log('Global mobile search initialized successfully');
    },
    
    setupEventListeners: function() {
      // Touch-friendly focus
      this.input.addEventListener('touchstart', () => {
        setTimeout(() => {
          this.input.focus();
        }, 100);
      });
      
      // Form submission with validation
      this.form.addEventListener('submit', (e) => {
        const query = this.input.value.trim();
        if (!query) {
          e.preventDefault();
          this.showValidationError();
          return false;
        }
        
        this.trackSearch(query);
      });
      
      // Clear validation on input
      this.input.addEventListener('input', () => {
        this.clearValidationError();
      });
      
      // Clear button functionality
      this.input.addEventListener('input', () => {
        this.toggleClearButton();
      });
    },
    
    showValidationError: function() {
      this.input.style.borderColor = '#fecaca';
      this.input.focus();
      setTimeout(() => {
        this.clearValidationError();
      }, 1500);
    },
    
    clearValidationError: function() {
      this.input.style.borderColor = '';
    },
    
    toggleClearButton: function() {
      const wrapper = document.querySelector('.global-mobile-search-input-wrapper');
      let clearButton = wrapper.querySelector('.mobile-search-clear');
      
      if (this.input.value.length > 0 && !clearButton) {
        clearButton = document.createElement('button');
        clearButton.className = 'mobile-search-clear';
        clearButton.innerHTML = '×';
        clearButton.type = 'button';
        clearButton.style.cssText = `
          position: absolute;
          right: 60px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          font-size: 20px;
          color: #6c757d;
          cursor: pointer;
          padding: 4px;
          z-index: 10;
          transition: color 0.2s ease;
        `;
        
        clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.input.focus();
          clearButton.remove();
        });
        
        clearButton.addEventListener('mouseover', () => {
          clearButton.style.color = '#DC2626';
        });
        
        clearButton.addEventListener('mouseout', () => {
          clearButton.style.color = '#6c757d';
        });
        
        wrapper.appendChild(clearButton);
      } else if (this.input.value.length === 0 && clearButton) {
        clearButton.remove();
      }
    },
    
    trackSearch: function(query) {
      // Analytics tracking
      if (typeof gtag === 'function') {
        gtag('event', 'search', {
          'event_category': 'global_mobile_search',
          'search_term': query,
          'event_label': window.location.pathname
        });
      }
      
      // Enhanced tracking with page context
      if (typeof window.dataLayer === 'object') {
        window.dataLayer.push({
          'event': 'mobile_search',
          'search_term': query,
          'page_type': document.body.className,
          'timestamp': new Date().toISOString()
        });
      }
    },
    
    setupAnalytics: function() {
      // Track mobile search visibility
      if (typeof gtag === 'function') {
        gtag('event', 'mobile_search_visible', {
          'event_category': 'mobile_ux',
          'event_label': window.location.pathname
        });
      }
    }
  };
  
  // Initialize global mobile search
  globalMobileSearch.init();
});